import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

import { AppRouteNames } from '@tallo/investor/navigation';

/**
 * Marks the route as available only locally in development mode.
 * For cases when feature isn't production ready yet.
 */
export function hideOnProdGuard(
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
) {
  if (process.env.ENV === 'production') {
    return next({ name: AppRouteNames.NOT_FOUND });
  }

  next();
}
